export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'de-DE',
}));
